import React, { Component } from 'react'
import GoogleTagManager from 'gtm'

import MenuOffCanvas from 'components/MenuOffCanvas'
import Header from 'components/Header'
import Footer from 'components/Footer'

import SelectedRegionController from 'modules/Controllers/SelectedRegion/SelectedRegionController'
import SurveyControllerContainer from 'modules/Controllers/Survey/SurveyControllerContainer'
import HTMLTitleController from 'modules/Controllers/HTMLTitle/HTMLTitleController'
import IndicatorEvolutionContainer from 'modules/Content/IndicatorEvolutionContainer'

class IndicatorEvolutionPage extends Component {

  render() {
    return (
      <div className="App">
        <GoogleTagManager gtmId="GTM-NXH8F9G" />
        <SelectedRegionController />
        <SurveyControllerContainer />
        <MenuOffCanvas />
        <Header />
        {/* <LayerHeader /> */}
        <div className="container-fluid ork-gray-box">
          <IndicatorEvolutionContainer />
        </div>
        <Footer />
        <HTMLTitleController />
      </div>
    )
  }
}

export default IndicatorEvolutionPage;



// WEBPACK FOOTER //
// ./src/pages/IndicatorEvolutionPage/IndicatorEvolutionPage.jsx